<template>
  <div>
    <MediumModal
      :is-open="open"
      @close="close"
    >
      <template #header>
        <div class="flex justify-between items-center">
          Check-In Customer
          <button
            @click="emitCreate()"
            type="button"
            class="inline-flex items-center px-3 py-1.5 border border-gray-400 text-sm font-medium rounded-md shadow-sm text-blue-600 bg-gray-100"
          >
            <PlusSmIconSolid
              class="-ml-0.5 mr-2 h-5 w-5"
              aria-hidden="true"
            />
            Create
          </button>
        </div>
      </template>

      <div class="mt-4">
        <div class="grid grid-cols-2 gap-5">
          <div class="input-group col-span-2">
            <div class="mt-1 flex rounded-md shadow-sm">
              <div class="relative flex items-stretch grow focus-within:z-10">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <UsersIcon
                    class="h-5 w-5 text-gray-400"
                    aria-hidden="true"
                  />
                </div>
                <input
                  v-model="searchQuery"
                  type="text"
                  name="search_customer"
                  id="search_customer"
                  class="focus:ring-blue-600 focus:border-blue-600 block w-full rounded-none rounded-l-md pl-10 sm:text-sm border-gray-400 rounded-r-md"
                  placeholder="John Doe"
                />
              </div>
              <!--                            <button v-if="selectedCustomer" @click="openConfirm();" type="button" class="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-400 text-sm font-semibold rounded-r-md text-gray-100 bg-blue-600 hover:bg-blue-600 shadow">-->
              <!--                                <span>Check-In</span>-->
              <!--                            </button>-->
            </div>
          </div>
        </div>

        <div
          v-if="searchQuery"
          class="max-w-xl pt-4"
        >
          <div class="flex-1 relative">
            <ul
              ref="results"
              class="space-y-1"
            >
              <li
                v-if="searching"
                class="px-1 pt-1 pb-2 font-bold border-b border-gray-400"
              >
                Searching...
              </li>
              <li
                v-if="!searching"
                v-for="item in searchResults"
                :key="`${item.id}`"
                class="hover:bg-gray-300 p-1 border-b border-gray-400 flex justify-between items-center"
                tabindex="0"
              >
                <div
                  @click="selectCustomer(item)"
                  class="cursor-pointer"
                >
                  <div class="font-semibold text-base text-blue-600">
                    <span>Customer #</span>
                    <span>{{ item.id }}: {{ item.name }}</span>
                  </div>
                  <div class="font-semibold text-sm text-gray-600">
                    <span>Email: </span>
                    {{ item.email }}
                  </div>
                  <div
                    v-if="item.patient_number"
                    class="font-semibold text-sm text-gray-600"
                  >
                    <span>Patient ID: </span>
                    {{ item.patient_number }}
                  </div>
                  <div
                    v-if="item.address?.formatted_address"
                    class="font-semibold text-sm text-gray-600"
                  >
                    <span>Address: </span>
                    {{ item.address?.formatted_address }}
                  </div>
                  <div
                    v-if="item.license_number"
                    class="font-semibold text-sm text-gray-600"
                  >
                    <span>License: </span>
                    {{ item.license_number }}
                  </div>
                </div>
                <div>
                  <a
                    v-if="!item.has_active_visit"
                    @click.prevent="
                      () => {
                        selectCustomer(item)
                        openConfirm()
                      }
                    "
                    class="border border-gray-400 text-blue-600 px-4 py-1 bg-gray-100 font-semibold rounded-full hover:bg-blue-600 hover:text-gray-100 mr-2"
                    href="#"
                  >
                    Check-In
                  </a>
                  <!--                                    <a v-if="! item.has_active_visit" @click.prevent="emitEditAndCheckInCustomer(item);" class="border border-gray-400 text-blue-600 px-4 py-1 bg-gray-100 font-semibold rounded-full hover:bg-blue-600 hover:text-gray-100" href="#">-->
                  <!--                                        Confirm-->
                  <!--                                    </a>-->
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <CustomerCheckInModal
        v-model:open="showConfirm"
        :customer="selectedCustomer"
        @complete="complete"
        @edit="emitEditAndCheckInCustomer"
        :location-id="this.locationId"
      />
    </MediumModal>
  </div>
</template>

<script>
import MediumModal from '@/Components/Modals/MediumModal.vue'
import CustomerCheckInModal from '@/Components/Modals/Customers/CheckInModal'
import { PlusSmIcon as PlusSmIconSolid, UsersIcon, UserAddIcon, ChevronDownIcon } from '@heroicons/vue/solid'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import interactsWithCurrentLocation from '@/Mixins/interactsWithCurrentLocation'
import getsErrors from '@/Mixins/getsErrors'

export default {
  mixins: [interactsWithCurrentLocation, getsErrors],

  components: {
    MediumModal,
    PlusSmIconSolid,
    UsersIcon,
    UserAddIcon,
    ChevronDownIcon,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    CustomerCheckInModal
  },

  props: {
    open: {
      type: Boolean,
      default: false
    },
    /**
     * Location ID to pre-select
     */
    locationId: {
      type: Number,
      default: null
    },
    /**
     * Default the search query to.
     */
    defaultQuery: {
      type: String,
      default: null
    },
    /**
     * An object of default customer details to use in search. Produced from ScanData.
     */
    defaultDetails: {
      type: Object,
      default() {
        return null
      }
    }
  },

  emits: ['update:open'],

  data() {
    return {
      searchQuery: this.defaultQuery,
      searching: false,
      searchResults: false,
      selectedCustomer: null,
      showConfirm: false
    }
  },

  watch: {
    defaultQuery(newVal, oldVal) {
      if (newVal && !this.searchQuery) {
        this.searchQuery = newVal
      }

      if (!newVal && this.searchQuery === oldVal) {
        this.searchQuery = null
      }
    },
    searchQuery(newVal, oldVal) {
      if (!newVal) {
        this.clearSearch()
      } else if (!this.selectedCustomer || this.selectedCustomer.email !== newVal) {
        this.clearSelectedCustomer()
        this.search()
      }
    }
  },

  methods: {
    clearSearch() {
      this.searchQuery = null
      this.searchResults = []
      this.searching = false
    },
    clearSelectedCustomer() {
      this.selectedCustomer = null
    },
    close() {
      this.closeConfirm()
      this.$emit('update:open', false)
      this.clearSearch()
      this.clearSelectedCustomer()
    },
    openConfirm() {
      // this.$emit('update:open', false);
      this.showConfirm = true
    },
    closeConfirm() {
      this.$emit('update:open', true)
      this.showConfirm = false
    },
    search: _.debounce(
      function () {
        this.searching = true

        let payload = this.defaultDetails || {}

        axios.post(route('customers.search'), { ...payload, query: this.searchQuery }).then((response) => {
          console.log('Found results', response.data.data)
          this.searchResults = response.data.data || []
          console.log('Saved results', this.searchResults)
          this.searching = false
        })
      },
      500,
      {
        leading: false,
        trailing: true
      }
    ),
    selectCustomer(customer) {
      this.selectedCustomer = customer
      // this.clearSearch();
    },
    emitEditAndCheckInCustomer(customer) {
      console.log('emitEditAndCheckInCustomer', customer)
      this.$emit('create', customer)
      this.clearSearch()
      this.clearSelectedCustomer()
    },
    complete() {
      this.close()
      this.clearSearch()
      this.clearSelectedCustomer()
    },
    emitCreate() {
      this.$emit('create', this.selectedCustomer)
    }
  }
}
</script>
